import styled from '@emotion/styled';
import { ArrowDown, ArrowUp, MoveDown, MoveUp } from 'lucide-react';
import React, { useEffect, useReducer } from 'react';
import InspectorSection from '../shared/inspector-section';
import type { ObjectInspectorProps } from '../types';

const LayerSection: React.FC<ObjectInspectorProps> = ({ object, editor }) => {
  const [, bump] = useReducer((n: number) => n + 1, 0);

  useEffect(() => {
    const offMod = editor.on('object:modified', bump);
    const offAdd = editor.on('object:added', bump);
    const offRem = editor.on('object:removed', bump);
    const offLoad = editor.on('canvas:loaded', bump);
    return () => {
      offMod();
      offAdd();
      offRem();
      offLoad();
    };
  }, [editor]);

  const layers = editor.layers;
  const canUp = layers?.canMoveUp(object) ?? false;
  const canDown = layers?.canMoveDown(object) ?? false;

  if (!layers) return null;

  return (
    <InspectorSection title="Layer">
      <Grid>
        <Button type="button" disabled={!canUp} onClick={() => layers.bringForward(object)}>
          <ArrowUp size={14} />
          <span>На слой выше</span>
        </Button>
        <Button type="button" disabled={!canUp} onClick={() => layers.bringToFront(object)}>
          <MoveUp size={14} />
          <span>На верх</span>
        </Button>
        <Button type="button" disabled={!canDown} onClick={() => layers.sendBackwards(object)}>
          <ArrowDown size={14} />
          <span>На слой ниже</span>
        </Button>
        <Button type="button" disabled={!canDown} onClick={() => layers.sendToBack(object)}>
          <MoveDown size={14} />
          <span>На низ</span>
        </Button>
      </Grid>
    </InspectorSection>
  );
};

export default LayerSection;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  font-size: 12px;
  color: #111827;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #f3f4f6;
  }

  &:disabled {
    color: #9ca3af;
    cursor: not-allowed;
    background: #f9fafb;
  }
`;
